import { apiGet, apiPost, apiPut, apiDelete } from "../../api/apiClient";

const BASE = "/api/admin";

export const fetchSubscription = (candidateId) =>
  apiGet(`${BASE}/candidates/${candidateId}/subscription`);

export const createSubscription = (candidateId, payload) =>
  apiPost(`${BASE}/candidates/${candidateId}/subscription`, payload);

export const updateSubscription = (id, payload) =>
  apiPut(`${BASE}/subscriptions/${id}`, payload);

export const extendSubscription = (id, payload) =>
  apiPut(`${BASE}/subscriptions/${id}/extend`, payload);
